module.exports = __webpack_public_path__ + "static/media/logo-white.10004b00.png";